var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraduationHat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 29.6133C27.5622 29.6133 34.5352 27.4578 34.5352 23.461V17.4067L22.2965 21.9963C21.8735 22.1523 21.4396 22.2305 21 22.2305C20.5604 22.2305 20.1265 22.1523 19.7119 21.9985L7.38281 17.4064V23.461C7.38281 27.4578 14.4378 29.6133 21 29.6133Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2124 9.99944L21.4428 2.61663C21.1477 2.51825 20.8523 2.51825 20.5572 2.61663L0.984055 9.92574H21C21.6796 9.92574 22.2305 10.4766 22.2305 11.1562C22.2305 11.8358 21.6796 12.3867 21 12.3867H0V38.2265C0 38.9068 0.550507 39.457 1.23047 39.457C1.85403 39.457 2.36833 38.9933 2.45004 38.3922L2.5247 38.6158C2.73843 39.257 3.43217 39.6095 4.08073 39.3932C4.72481 39.1795 5.07344 38.4825 4.85811 37.8372L2.46094 30.6454V12.9526L20.5572 19.6958C20.7046 19.7451 20.8523 19.7695 21 19.7695C21.1477 19.7695 21.2954 19.7451 21.4428 19.6958L41.2124 12.313C41.6802 12.1406 42 11.6731 42 11.1562C42 10.6393 41.6802 10.1718 41.2124 9.99944Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraduationHat);
export default __webpack_public_path__ + "static/media/graduation-hat.405b21e277b6c2c0beac91ec3904996a.svg";
export { ForwardRef as ReactComponent };